import React, { useContext, useEffect, useState } from 'react';

import { fbmApi as api } from 'api/fbm';
import { UserContext } from 'contexts/UserContext';
import { FormComponent, Notifications } from 'shared';

function CreateFBMUserAccount({}) {
    const [notification, setNotification] = useState({ text: null, level: null });
    const { fbmAccount, user } = useContext(UserContext);

    const formFields = [
        {
            name: 'email',
            inputElement: 'textField',
            label: 'Email',
            gridValue: 3,
            inputProps: { required: true },
        },
        {
            name: 'firstName',
            inputElement: 'textField',
            label: 'First Name',
            gridValue: 3,
            inputProps: { required: false },
        },
        {
            name: 'lastName',
            inputElement: 'textField',
            label: 'Last Name',
            gridValue: 3,
            inputProps: { required: false },
        },
    ];

    return (
        <div>
            <h1>Create User</h1>
            <Notifications options={notification} />
            <FormComponent
                formFields={formFields}
                onSubmit={async (formData, resetForm) => {
                    const sendParams = {
                        email: formData.email,
                        firstName: formData.firstName,
                        lastName: formData.lastName,
                    };

                    if (!user.fbm) {
                        sendParams.fbmAccount = fbmAccount.fbmAccountName;
                    }

                    const response = await api.createFBMUserAccount(sendParams);
                    if (response.status === false) {
                        let message = 'Error creating user';
                        if (response) {
                            message += `: ${response.msg}`;
                        }
                        setNotification({ text: message, level: 'error' });
                    } else {
                        setNotification({ text: 'User created!', level: 'success' });
                        resetForm();
                    }
                }}
            />
        </div>
    );
}

export { CreateFBMUserAccount };
